import { useEffect, useState } from "react";

const width = {
  no: "w-[3.5rem]",
  nomor_polisi: "w-[8rem]",
  jenis: "w-[12rem]",
  count: "w-[6rem]",
};

const ReportTemplateSummary = (props) => {
  const { list, listRaw, groupNames, groupMap } = props;
  const [rows, setRows] = useState([]);

  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    const _rows = [];
    let no = 1;
    let totalCount = 0;
    for (let groupName of groupNames) {
      const group = groupMap[groupName];
      if (group) {
        const groupData = group.group_data;

        const row = {
          no: no++,
          nomor_polisi: groupData.nomor_polisi,
          jenis: `${groupData.jenis_mobil}, ${groupData.tahun}`,
          count: group.group_count,
        };
        totalCount += group.group_count;
        _rows.push(row);
      }
    }
    setRows(_rows);
    setTotalCount(totalCount);
  }, [list, listRaw, groupNames, groupMap]);

  return (
    <table>
      <thead>
        <tr className="row-start-start text-sm w-[29.5rem] bg-zinc-100 font-semibold text-slate-800 ">
          <td
            className={`border-zinc-300 border w-full  px-2 h-full pb-2 pt-3 `}
          >
            SUMMARY LAPORAN
          </td>
        </tr>
        <tr className="row-start-start text-sm bg-zinc-100 font-semibold text-slate-800 ">
          <td
            className={`${width.no} row-center-center border-zinc-300 border border-t-0 px-2 h-full pb-2 pt-3 `}
          >
            #
          </td>

          <td
            className={`${width.nomor_polisi} border-zinc-300 border border-t-0  border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            NOMOR POLISI
          </td>

          <td
            className={`${width.jenis} border-zinc-300 border border-t-0  border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            JENIS
          </td>

          <td
            className={`${width.count} col-start-end border-zinc-300 border border-t-0  border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            MASALAH
          </td>
        </tr>
      </thead>
      <tbody>
        {rows &&
          rows.length > 0 &&
          rows.map((el) => {
            return (
              <tr
                key={`summary-${el.no}`}
                className="row-start-start w-full text-sm text-slate-700 !items-stretch"
              >
                <td
                  className={`${width.no} row-center-center border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
                >
                  {el.no}
                </td>
                <td
                  className={`${width.nomor_polisi} row-start-start border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
                >
                  {el.nomor_polisi}
                </td>
                <td
                  className={`${width.jenis} row-start-start border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
                >
                  {el.jenis}
                </td>
                <td
                  className={`${width.count} col-start-end row-start-start border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
                >
                  {el.count.toLocaleString("id-ID")}
                </td>
              </tr>
            );
          })}
      </tbody>
      <tfoot>
        <tr className="row-start-start text-sm w-[29.5rem] bg-zinc-100 font-semibold text-slate-800 ">
          <td
            className={`row-end-start w-[23.5rem] border-zinc-300 border border-t-0 px-2 h-full pb-2 pt-3 `}
          >
            TOTAL MASALAH
          </td>
          <td
            className={`row-end-start ${width.count} border-zinc-300 border border-t-0 border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            {totalCount.toLocaleString("id-ID")}
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

export default ReportTemplateSummary;
